/* klaasje-news
   ------------
   Eén taak: de melding onder de nieuwsbrief alleen tonen als de bezoeker
   hier zijn adres heeft achtergelaten.

   Shopify's form.posted_successfully? hoort namelijk bij de pagina en niet
   bij het formulier, dus elk {% form 'customer' %} op de pagina ziet na een
   verzending dezelfde vlag. Op de homepage zette de nieuwsbrief daarmee ook
   het seintje bij de koopsectie aan, dat zichzelf vervolgens in beeld
   scrolde. Daarom onthoudt elk formulier vlak voor het verzenden zijn eigen
   id en toont alleen dat formulier zijn melding.

   Kan er geen sessionStorage bij, dan blijft de anchor van Shopify's
   redirect over (/contact#<form-id>).
*/
(function () {
  var KEY = 'klaasje_form_verzonden';

  function lees() {
    try {
      return sessionStorage.getItem(KEY);
    } catch (e) {
      return null;
    }
  }

  function onthoud(id) {
    try {
      sessionStorage.setItem(KEY, id);
    } catch (e) {
      // niets: dan valt de controle hieronder terug op de anchor
    }
  }

  function vanOns(form) {
    var id = lees();
    if (id !== null) return id === form.id;
    return window.location.hash === '#' + form.id;
  }

  function start() {
    var formulieren = document.querySelectorAll('.klaasje-news__form');
    Array.prototype.forEach.call(formulieren, function (form) {
      form.addEventListener('submit', function () {
        onthoud(form.id);
      });

      if (vanOns(form)) return;
      var msg = form.querySelector('.klaasje-news__msg');
      if (msg) msg.remove();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
